import FormattedAddress from "components/Atoms/FormattedAddress";
import { VenueSidePanel } from "components/SidePanel/Venue/VenueSidePanel";
import React from "react";

interface Props {
  venue: server.dto.VenueSmall
  displayTooltip: boolean
}

const ReadonlyVenue = (props: Props) => {
  React.useEffect(() => {
    // The map code is written in jQuery........
    const mapDialog = $("#mapDialog");

    if (mapDialog.length === 0) {
      ($("<div />", {
        id: "mapDialog"
      }) as any).venuemap({ closeOutside: true });
    }

    return () => {
      if (mapDialog.length > 0) {
        (mapDialog as any).venuemap("destroy");
      }
    }
  }, [props.venue?.venueId]);

  const onOpenMap = () => {
    ($("#mapDialog") as any).venuemap("open", props.venue);
  };

  return <div className="flex gap" style={{ flex: 1 }}>
    <div>
      <div>
        {props.displayTooltip
          ? <VenueSidePanel venueId={props.venue.venueId} trigger={<a>{props.venue.name}</a>} fallbackIfNoPermission={<strong>{props.venue.name}</strong>} />
          : <strong>{props.venue.name}</strong>}
      </div>
      <div><FormattedAddress address={props.venue.address} /></div>
    </div>
    <div onClick={onOpenMap}>
      <a>
        <i className="btnGoogleMaps icon-map-marker"></i>
      </a>
    </div>
  </div>;
};

export default ReadonlyVenue;
